import { IconButton } from '@mui/material'
import { darken, styled } from '@mui/material/styles'

export const CircleIconButton = styled(IconButton)(({ theme }) => ({
  border: '1px solid #e4e4e4',
  background: 'white',
  boxShadow: '1px 1px 6px 0px rgba(50, 50, 71, 0.05)',
  [theme.breakpoints.down('lg')]: {
    border: 'none',
    boxShadow: 'none'
  }
}))
